const isWeb = true;
import { isDianpingAppOrWebview } from '@nibfe/mkt-env-api';
import hotCity from './city_hot_data';
const MT_CITY_CDN = 'https://s3.meituan.net/static-prod01/com.sankuai.dde.lowcode.docs-files/mt_cityid.json';
const DP_CITY_CDN = 'https://s3.meituan.net/static-prod01/com.sankuai.dde.lowcode.docs-files/dp_cityid.json';
const isDpAPP = isDianpingAppOrWebview();
/**
 * 是否使用美团城市ID系统
 * 无法判断时默认为true
 */
export const isMtCity = !isDpAPP;
/**
 * Web环境下获取城市列表
 *
 * 采用XHR的原因：
 * 1. 目前城市列表托管至CDN，其返回的access-control-allow-origin为*，而meituan-uni-network的request默认withCredentials为true，会导致跨域问题
 * 2. 不使用fetch：有兼容问题
 * 3. 不引入axios：会增加包体积
 * @param isMt 是否是美团城市
 * @returns 城市列表
 */
export const getCityListApiInWeb = () => {
    return new Promise((resolve, _reject) => {
        // if (isWeb) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', isMtCity ? MT_CITY_CDN : DP_CITY_CDN, true);
        xhr.send();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                // 请求完成
                if (xhr.status === 200) {
                    try {
                        const res = JSON.parse(xhr.responseText);
                        resolve(res);
                    }
                    catch (error) {
                        resolve([]);
                    }
                }
                else {
                    resolve([]); // 处理非 200 状态码
                }
            }
        };
        // }
    });
};
/**
 * 获取热门城市列表
 * @returns 热门城市列表
 */
export const getHotCityListApi = () => {
    if (isMtCity) {
        return hotCity.mt;
    }
    return hotCity.dp;
};
